var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.875C9.55435 14.875 10.3508 14.7166 11.0939 14.4088C11.8371 14.101 12.5123 13.6498 13.081 13.081C13.6498 12.5123 14.101 11.8371 14.4088 11.0939C14.7166 10.3508 14.875 9.55435 14.875 8.75C14.875 7.94565 14.7166 7.14918 14.4088 6.40606C14.101 5.66294 13.6498 4.98773 13.081 4.41897C12.5123 3.85021 11.8371 3.39905 11.0939 3.09124C10.3508 2.78343 9.55435 2.625 8.75 2.625C7.12555 2.625 5.56763 3.27031 4.41897 4.41897C3.27031 5.56763 2.625 7.12555 2.625 8.75C2.625 10.3745 3.27031 11.9324 4.41897 13.081C5.56763 14.2297 7.12555 14.875 8.75 14.875Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 18.375L13.125 13.125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9c41f6bfd3f10c3238ec6b03bf1e5d92.svg";
export { ForwardRef as ReactComponent };